import PropTypes from 'prop-types';

export const props = {
  listPromotions: PropTypes.array,
};
